import { render } from "./FootballRatingBlock.vue?vue&type=template&id=1f71fc5e&scoped=true"
import script from "./FootballRatingBlock.vue?vue&type=script&lang=js"
export * from "./FootballRatingBlock.vue?vue&type=script&lang=js"

import "./FootballRatingBlock.vue?vue&type=style&index=0&id=1f71fc5e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f71fc5e"]])

export default __exports__